import React from 'react'
import './Search_product_modal.css'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

const Search_product_modal = (props) => {
    return (
        <>
            <Modal
                {...props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='common_modal search_product_modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Search
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='searchprod_div'>
                        <Form>
                            <div className='from-group'>
                                <Form.Label>Search</Form.Label>
                                <Form.Control type="search" placeholder="Search here..." />
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Search_product_modal